// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export let BaseSettingsUtils = null;
export function BaseGeneralSettingsUtilsInstanceCreator(settingsUtils) {
    BaseSettingsUtils = settingsUtils;
}
